import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { useAppDispatch, useAppSelector } from '../ReduxToolkit/Hooks';
import { logout } from '../ReduxToolkit/Auth/AuthSlice';
import { toast } from 'react-toastify';
import { useAuthModal } from '../contexts/AuthModalContext';
import { FloatingRegisterCTA } from '../components/ui/FloatingRegisterCTA';
import { FloatingContactChat } from '../components/ui/FloatingContactChat';

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const favorites: any[] = [];
  const { currentUser } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const documents: any[] = [];

  const { openAuthModal } = useAuthModal();

  const handleLogout = () => {
    dispatch(logout());
    toast.info("Vous avez été déconnecté.");
  };

  const handleSearchQuick = (term: string) => {
    navigate(`/search?q=${term}`);
  };

  return (
    <div className="min-h-screen bg-surface-base flex flex-col justify-between">
      <Header
        currentView={location.pathname.replace('/', '') || 'home'}
        setView={(view) => navigate(`/${view}`)}
        onSearchQuick={handleSearchQuick}
        favoritesCount={favorites.length}
        currentUser={currentUser}
        documents={documents}
        onLogout={handleLogout}
        onLogin={openAuthModal}
      />

      <main className="flex-grow animate-fade-in divide-y">
        <Outlet />
      </main>

      <FloatingRegisterCTA />
      <FloatingContactChat />

      <Footer setView={(view) => navigate(`/${view}`)} />
    </div>
  );
};

export default AppLayout;
